/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
	Button,
	Modal,
	Form as FormUi,
	Input,
	Checkbox,
	Dropdown,
	Container,
	Segment,
	Icon,
	Table,
} from "semantic-ui-react";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
	successAlertDispatcher,
	errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import cogoToast from "cogo-toast";
import allAxiosCommonTA from "../../components/axiosComponent/allAxiosCommonTA";

const ClubInvoice = ({
	values,
	touched,
	errors,
	isSubmitting,
	handleSubmit,
	setFieldValue,
	t,
	...props
}) => {
	const [modalOpen, setmodalOpen] = useState(false);
	let [isFormSubmitting, setIsFormSubmitting] = useState(false);

	useEffect(() => {
		console.log("SELECTED CLUB INVOICE...........................")
		console.log(props)
	}, [props.invoices]);
	let handleOpen = () => setmodalOpen(true);

	let handleClose = () => {
		setmodalOpen(false);
	};

	let clubInvoice = () => {
		let invoiceIdsList = [];
		let deliveryNumber = document.getElementById("delivery_ref_number").value;
		for (let index = 0; index < props.invoices.length; index++) {
			let invoiceID = props.invoices[index].id;
			invoiceIdsList.push(invoiceID)
		}
		console.log(invoiceIdsList)
		console.log(deliveryNumber.length)

		if (deliveryNumber.length > 0) {
			allAxiosCommonTA({
				url: "/deliveries/invoice/club",
				method: "post",
				Items: { invoice_ids: invoiceIdsList, delivery_number: deliveryNumber },
			})
				.then((response) => {
					console.log(response)
					cogoToast.info(response.data.message, { hideAfter: 7.5 });
					setTimeout(() => {
						handleClose();
						window.location.reload();
					}, 100);
				})
				.catch((err) => {
					console.log(err)
					if (err?.response?.data?.message)
						cogoToast.error(err.response.data.message);
					else
						cogoToast.error("Error While Clubbing invoice.");
				});
		} else {
			cogoToast.error("Delivery Number is required.");
		}
	}

	return (
		<div>
			<Modal
				open={modalOpen}
				onClose={handleClose}
				size="small"
				style={{
					/* padding: '50px 0 50px 0' */
				}}
				trigger={
					<Button
						type="button"
						onClick={handleOpen}
						size="mini"
						color="green"
						className="m-2 w3-hover-green"
						circular
					>
						{"Club Invoice"}
					</Button>
				}
			>
				<Modal.Header className="p-bold-100">
					<div className="d-flex justify-content-between">
						<label className="font-weight-normal">{"Club Invoice"}</label>
						<div className="form-inline">
							<i onClick={handleClose} className="fas fa-times"></i>
						</div>
					</div>
				</Modal.Header>
				<Modal.Content scrolling>
					<label>Delivery Reference No.</label><br /><br />
					<textarea rows="4" cols="50" id="delivery_ref_number" style={{ padding: '10px' }} />
					<div className="display-flex-center-justify-center" style={{ padding: '10px 0 10px 0' }}>
						<button
							className="submit-generate-order w3-button w3-blue w3-hover-blue w3-round w3-small"
							onClick={clubInvoice}
							disabled={isFormSubmitting}
						>
							{isFormSubmitting ? <Icon name="spinner" /> : <span>Submit</span>}
						</button>
					</div>
				</Modal.Content>
				{/* </Formiker> */}
			</Modal>
		</div>
	);
};
// TODO: validation

export default ClubInvoice;
